import { render, staticRenderFns } from "./MailDetails.vue?vue&type=template&id=c8ded502&scoped=true"
import script from "./MailDetails.vue?vue&type=script&lang=js"
export * from "./MailDetails.vue?vue&type=script&lang=js"
import style0 from "./MailDetails.vue?vue&type=style&index=0&id=c8ded502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ded502",
  null
  
)

export default component.exports